import { httpPost } from "../../../network/fetch";
import { ParcelAnnounceTrackerCommand } from "./parcel-announce-tracker-command";

export const ParcelAnnounceTrackerHandler = async (command: ParcelAnnounceTrackerCommand) => {
    command.parcel.updateParcelTrackingData(command.carrier, command.parcelTracker);
    await httpPost({
        url: `/parcels/operation/${command.parcel.operationCode}/batch/${command.parcel.batchId}/parcel/${command.parcel.id}/trackingdata`,
        data: {
            parcelTracker: command.parcelTracker,
            carrier: command.carrier,
        },
    });

    return command.parcel;
};
